/* eslint-disable import/prefer-default-export */
export enum SCREEN {
    HOME = 'HOME',
    TV_GUIDE = 'TV_GUIDE',
    RECORDINGS = 'RECORDINGS',
    ON_DEMAND = 'ONDEMAND',

    SPLASH_SCREEN = 'SPLASH_SCREEN',
    LOGIN_SCREEN = 'LOGIN',
    QR_LOGIN_SCREEN = 'QR_LOGIN',
    FTI_TUTORIAL = 'TUTORIAL',
    PERSONALIZE_SCREEN = 'PERSONALIZE_SCREEN',
    WELCOME_SCREEN = 'WELCOME',
    LANDING_SCREEN = 'LANDING',
    ROOT = 'ROOT',
    MODULAR_ROOT = 'MODULAR_ROOT',
    EPG = 'EPG',
    LANGUAGE = 'LANGUAGE',
    ABOUT = 'ABOUT',
    SETTINGS = 'SETTINGS',
    SEARCH = 'SEARCH',
    DETAILS = 'DETAILS',
    DETAILS_VOD_HIGH_USAGE_RESTRICTION = 'DETAILS_VOD_HIGH_USAGE_RESTRICTION',
    PAGE = 'PAGE',
    COLLECTION = 'COLLECTION',
    PARENTAL_CONTROL_AND_PIN = 'PARENTAL_CONTROL_AND_PIN',
    PARENTAL_CONTROL = 'PARENTAL_CONTROL',
    PIN_SETUP = 'PIN_SETUP',
    PIN_SETUP_INTRODUCTION = 'PIN_SETUP_INTRODUCTION',
    PIN_SETUP_CREATE = 'PIN_SETUP_CREATE',
    PIN_SETUP_SUCCESS = 'PIN_SETUP_SUCCESS',
    PIN_SETUP_UNSUCCESS = 'PIN_SETUP_UNSUCCESS',
    AUDIO_AND_SUBTITLES = 'AUDIO_AND_SUBTITLES',
    SETTINGS_AUDIO = 'SETTINGS_AUDIO',
    SETTINGS_SUBSCRIPTIONS = 'SETTINGS_SUBSCRIPTIONS',
    SETTINGS_SUBTITLES = 'SETTINGS_SUBTITLES',
    SETTINGS_SUBTITLES_FONT_SIZE = 'SETTINGS_SUBTITLES_FONT_SIZE',
    CHANNELS_LINEUP = 'CHANNELS_LINEUP',
    STANDARD_LIST = 'STANDARD_LIST',
    MY_LIST = 'MY_LIST',
    EDIT_MY_LIST = 'EDIT_MY_LIST',
    SWITCH_CHANNEL_LIST = 'SWITCH_CHANNEL_LIST',
    SETTINGS_RECORDING_QUOTA = 'SETTINGS_RECORDING_QUOTA',
    SETTINGS_HELP = 'SETTINGS_HELP',
    SETTINGS_LOGOUT = 'SETTINGS_LOGOUT',
    SETTINGS_BACKEND_INFO = 'SETTINGS_BACKEND_INFO',
    SETTINGS_TERMS_CONDITIONS = 'SETTINGS_TERMS_CONDITIONS',
    SETTINGS_INTERNET_CONNECTION = 'SETTINGS_INTERNET_CONNECTION',
    SETTINGS_EPG_DISPLAY = 'SETTINGS_EPG_DISPLAY',
    SETTINGS_EPG_DISPLAY_OPTIONS = 'SETTINGS_EPG_DISPLAY_OPTIONS',
    PROFILES = 'PROFILES',
    ADD_PROFILE = 'ADD_PROFILE',
    PROFILE_TYPE = 'PROFILE_TYPE',
    PROFILE_AGE_RATING = 'PROFILE_AGE_RATING',
    PROFILE_AVATARS = 'PROFILE_AVATARS',
    MANAGE_PROFILE = 'MANAGE_PROFILE',
}
